import { Chip } from "@heroui/react";

/**
 * ActiveFilterChips - Displays active filters as removable chips
 *
 * @param {Object} filters - Current filter values object
 * @param {Object} filterLabels - Labels for filter keys, with optional getValueLabel function
 *   Example: { category_id: { label: "Kategori", getValueLabel: (val) => categoryName } }
 * @param {Function} onRemove - Callback when a filter chip is removed (key, value?)
 * @param {Array} excludeKeys - Keys to exclude from display (e.g., ['name'])
 */
const ActiveFilterChips = ({
    filters = {},
    filterLabels = {},
    onRemove,
    excludeKeys = [],
}) => {
    // Check if a filter value is active (non-empty)
    const isFilterActive = (value) => {
        if (value === null || value === undefined || value === "") return false;
        if (Array.isArray(value) && value.length === 0) return false;
        return true;
    };

    // Get active filters
    const activeFilters = Object.entries(filters).filter(
        ([key, value]) => !excludeKeys.includes(key) && isFilterActive(value),
    );

    if (activeFilters.length === 0) return null;

    // Format display value
    const formatValue = (key, value) => {
        const config = filterLabels[key];

        // If custom value label function exists, use it
        if (config?.getValueLabel) {
            return config.getValueLabel(value);
        }

        // Handle arrays
        if (Array.isArray(value)) {
            return `${value.length} dipilih`;
        }

        // Default: return value as string
        return String(value);
    };

    // Get label for filter key
    const getLabel = (key) => {
        return filterLabels[key]?.label || key;
    };

    return (
        <div className="flex flex-wrap items-center gap-2">
            <span className="text-default-500 text-sm">Filter aktif:</span>
            {activeFilters.map(([key, value]) => (
                <Chip
                    key={key}
                    variant="flat"
                    color="primary"
                    size="sm"
                    onClose={() => onRemove(key)}
                    classNames={{
                        closeButton: "text-primary-500 hover:text-primary-700",
                    }}
                >
                    <span className="font-medium">{getLabel(key)}:</span>{" "}
                    {formatValue(key, value)}
                </Chip>
            ))}
        </div>
    );
};

export default ActiveFilterChips;
